export default __webpack_public_path__ + "static/media/equipo_logo_060117_white.a2a0fbae.png";